// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2auYI","newExpiryDate":"styles_newExpiryDate__1t6k3","footer":"styles_footer__12rJP"};